<template>
    <el-dialog
        title="坏账"
        :visible.sync="badDebtDialogVisible"
        width="800px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-payable-dialog"
    >
        <div class="page_little_title">基本信息</div>
        <el-form
            ref="badDebtForm"
            :rules="badDebtFormRules"
            :model="badDebtForm"
            label-position="top"
            v-loading="formLoading"
        >
            <div>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="订单总金额" prop="total_price">
                            <el-input
                                disabled
                                placeholder="系统自动带出"
                                v-model="unpaidDetails.amount_info.total_price"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="已回款总金额" prop="total_repay_price">
                            <el-input
                                disabled
                                placeholder="请输入已回款总金额"
                                v-model="unpaidDetails.amount_info.total_repay_price"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="未回款金额" prop="no_repay_price">
                            <el-input
                                disabled
                                placeholder="请输入未回款金额"
                                v-model="unpaidDetails.amount_info.no_repay_price"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="坏账金额" prop="bad_debt_amount">
                            <el-input disabled placeholder="请输入坏账金额" v-model="badDebtForm.bad_debt_amount">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="操作时间" prop="operate_time">
                            <el-date-picker
                                format="yyyy-MM-dd HH:mm:ss"
                                placeholder="请选择操作时间"
                                type="datetime"
                                v-model="badDebtForm.operate_time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="备注" prop="remark">
                        <el-input
                            :rows="4"
                            maxlength="200"
                            placeholder="请输入备注信息"
                            type="textarea"
                            v-model="badDebtForm.remark"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="附件" prop="attachment">
                <div class="file_upload_wrap">
                    <div v-if="badDebtForm.attachment && badDebtForm.attachment.length === 0" class="file_outer_wrap">
                        <img
                            alt=""
                            src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                            width="36"
                        />
                        <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                        <p class="file_type_hint">支持png、jpg等格式</p>
                        <input class="upload_input" multiple type="file" @change="handleUploadFileChange($event)" />
                    </div>
                    <ul v-else class="upload_file_list">
                        <li v-for="(file, file_idx) in badDebtForm.attachment" :key="file_idx" class="upload_file_item">
                            <div class="file_left_wrap">
                                <img
                                    alt=""
                                    class="file_img"
                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                />
                                <div class="file_info_wrap">
                                    <p class="file_name" v-text="file.file_name"></p>
                                    <p class="file_size" v-text="file.file_size"></p>
                                </div>
                            </div>
                            <div class="file_right_wrap">
                                <el-tooltip content="预览" effect="dark" placement="top">
                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                        <i class="iconfont icon-yanjing"></i>
                                    </span>
                                </el-tooltip>
                                <span class="line"></span>
                                <el-tooltip content="删除" effect="dark" placement="top">
                                    <span
                                        class="handle_icon_wrap handle_icon_danger_wrap"
                                        @click="badDebtForm.attachment.splice(file_idx, 1)"
                                    >
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                        </li>
                        <li class="upload_file_btn_wrap">
                            <i class="el-icon-plus"></i>
                            <span>添加附件</span>
                            <input class="upload_input" multiple type="file" @change="handleUploadFileChange($event)" />
                        </li>
                    </ul>
                </div>
            </el-form-item>
            <el-image
                :preview-src-list="previewImgList"
                :src="previewImgSrc"
                ref="preview_img"
                style="display: none"
            ></el-image>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">提交</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { OrderMarkBadDebt, OrderUnpaidDetail } from "@/api";
import { uploadImg } from "@/utils/uploadOss";
import { formatDate, formatFileSize } from "@/utils";
export default {
    name: "BadDebt",
    props: {
        badDebtDialogVisible: {
            type: Boolean,
            default: false,
        },
        order_num: "",
    },
    data() {
        return {
            formLoading: true,
            unpaidDetails: {
                is_bad_debt: 0, // 1坏账 0正常
                basic_info: {},
                amount_info: {},
                other_info: {},
            },
            badDebtForm: {
                order_num: "",
                bad_debt_amount: "",
                operate_time: formatDate(new Date(), "date-second-time"),
                remark: "",
                attachment: [],
            },
            badDebtFormRules: {
                operate_time: [{ required: true, message: "请选择操作时间", trigger: "change" }],
            },
            payTypeList: [],
            btnDisabled: false,

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    created() {
        this.formLoading = false;
        if (this.order_num) {
            this.getOrderUnpaidDetail();
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:badDebtDialogVisible", false);
        },
        // 详情
        getOrderUnpaidDetail() {
            OrderUnpaidDetail({ order_num: this.order_num }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.unpaidDetails = data;
                    this.badDebtForm.bad_debt_amount = this.unpaidDetails.amount_info.no_repay_price;
                }
            });
        },
        //格式化输入的支付金额
        handlePayAmountBlur(formData, unpaid_amount) {
            formData["pay_amount"] = formData["pay_amount"].replace(/[^\d\.]/g, "");
            if (Number(formData["pay_amount"]) > Number(unpaid_amount)) {
                formData["pay_amount"] = unpaid_amount;
            }
            if (formData["pay_amount"]) {
                let amount = Math.abs(parseFloat(formData["pay_amount"]));
                const some = unpaid_amount.toString().split(".")[1].length;
                const parts = amount.toFixed(some).split(".");
                const integerPart = parts[0];
                const decimalPart = some > 0 ? (parts[1] ? parts[1] : "0".repeat(some)) : "";
                // 拼接成完整的金额格式
                formData["pay_amount"] = some > 0 ? `${integerPart}.${decimalPart}` : integerPart;
            }
        },
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024))
                    return that.$message.error("图片大小不允许超过5m");
                if (that.badDebtForm.attachment.length + files.length > 5)
                    return that.$message.error("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.badDebtForm.attachment.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 上传附件
        handleUploadFileChange(e) {
            const files = e.target.files;
            const that = this;
            Array.from(files).forEach((file) => {
                uploadImg(file, 50)
                    .then((res) => {
                        if (res.file_path) {
                            res.file_size = formatFileSize(file.size);
                            this.badDebtForm.attachment.push(res);
                            this.$forceUpdate();
                            e.target.value = "";
                        }
                        e.target.value = "";
                    })
                    .catch((error) => {
                        e.target.value = "";
                    });
            });
        },
        // 预览
        handleClickPreview(file) {
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleDialogConfirm() {
            this.$refs.badDebtForm.validate((valid) => {
                if (valid) {
                    this.btnDisabled = true;
                    this.formLoading = true;
                    const params = {
                        order_num: this.order_num,
                        bad_debt_amount: this.badDebtForm.bad_debt_amount,
                        operate_time: this.badDebtForm.operate_time,
                        remark: this.badDebtForm.remark,
                        attachment: this.badDebtForm.attachment,
                    };
                    OrderMarkBadDebt(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$emit("confirmSuccess");
                                        this.handleDialogClose();
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}
.custom-payable-dialog {
    .page_little_title {
        line-height: 22px;
        color: #333333;
        font-weight: 700;
        padding-left: 8px;
        position: relative;
        margin-bottom: 16px;

        &::before {
            width: 3px;
            height: 22px;
            border-radius: 2px;
            background: #409eff;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .upload_img_wrap {
            width: 48px;
            height: 48px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-icon-plus {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .voucher_item {
            width: 48px;
            height: 48px;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
}
</style>
